
// Modification des liens par défaut du menu ***********************
$(document).ready(function(){
  var newURLs = {
      'fr/agence': '#agence',
      'fr/conseil-strategique': '#conseil',
      'fr/coordination-generale': '#coordination',
      'fr/exposition-sponsoring': '#exposition',
      'fr/secretariat-scientifique': '#secretariat',
      'fr/gestion-participants': '#gestion',
      'fr/communication-presse': '#communication',
      'fr/contact': '#contact',
  };

  $('.mainmenu li a').each(function(){
      var currentHref = $(this).attr('href');
      var newHref = newURLs[currentHref];
      if (newHref) {
          $(this).attr('href', newHref);
      }
  });

  // fermeture du menu après un clique
  $('.mainmenu a').on('click', function() {
    closeNav();
  });

});


// Menu sticky ***********************
jQuery(document).ready(function($) {
  var $menu = $('.navigation'); // Mettre la classe du menu
  var offset = $menu.offset().top;

  $(window).on('resize', function() {
    offset = $menu.offset().top;
  });

  $(window).on('scroll', function() {
    var scrollTop = $(this).scrollTop();
    $menu.toggleClass('scrolled', scrollTop > offset);
  });

  // Ajouter un événement click pour chaque lien d'ancre
  $('a[href^="#"]').on('click', function(e) {
    // Empêcher le comportement par défaut
    e.preventDefault();

    // Récupérer l'id de la cible
    var targetId = $(this).attr('href');

    // Calculer la position de la cible en prenant en compte la hauteur du menu
    var targetPosition = $(targetId).offset().top - $menu.outerHeight();

    // Faire défiler doucement jusqu'à la cible
    $('html, body').animate({
      scrollTop: targetPosition
    }, 1000);
  });
});


